import { Component, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { TaskingAppStateService } from '@modules/tasks/services/state.service';

import { ListState } from '@modules/tasks/types/list-state';
import { Project } from '@modules/tasks/types/project';
import { Task } from '@modules/tasks/types/task';

import { FullFormBaseComponent } from '@modules/common/components/full-form-base/full-form-base.component';
import { AbstractMainViewComponent } from '@modules/common/components/main-view/main-view.component';
import { getStitchInstanceByStitchType } from '@modules/common/utils/stitch';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-tasks-main-view',
  templateUrl: './tasks-main-view.component.html',
  styleUrls: ['./tasks-main-view.component.less'],
  standalone: false,
})
export class TasksMainViewComponent extends AbstractMainViewComponent<
  StitchType.TASK | StitchType.PROJECT,
  Task | Project,
  FullFormBaseComponent<StitchType.TASK | StitchType.PROJECT, Task | Project, Record<string, AbstractControl>>,
  ListState
> {
  public readonly Project = Project;
  public readonly Task = Task;

  protected override readonly stateService = inject(TaskingAppStateService);

  protected handleNewTask(): void {
    const task = getStitchInstanceByStitchType(StitchType.TASK);
    this.stateService.seedTaskDraft(task);
    this.openCreateModal(task);
  }

  protected handleNewProject(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.PROJECT));
  }
}
